export const FOOTBALL_MODULE_NAME = 'football';
export const FOOTBALL_MODULE_PATH = '/football/';

export const RESULT_GAME_CARD = 0;
export const CORRECT_SCORE_GAME_CARD = 1;
export const GOALS_GAME_CARD = 2;

const WIN_DRAW_WIN = {
    name: 'WIN_DRAW_WIN',
    code: '9'
};
const CORRECT_SCORE = {
    name: 'CORRECT_SCORE',
    code: '10'
};
const TOTAL_GOALS = {
    name: 'TOTAL_GOALS',
    code: '11'
};
const DOUBLE_CHANCE = {
    name: 'DOUBLE_CHANCE',
    code: '12'
};
// const DOUBLE_CHANCE_1 = '13' const DOUBLE_CHANCE_2 = '14'
const UNDER_OVER_25 = {
    name: 'UNDER_OVER_25',
    code: '15'
};
const UNDER_OVER_15 = {
    name: 'UNDER_OVER_15',
    code: '16'
};
const ASIAN_HANDICAP = {
    name: 'ASIAN_HANDICAP',
    code: '17'
};
const UNDER_OVER = {
    name: 'UNDER_OVER',
    code: 'UNDER_OVER'
};
const UNDER_OVER_05 = {
    name: 'UNDER_OVER_05',
    code: '23'
};
const UNDER_OVER_35 = {
    name: 'UNDER_OVER_35',
    code: '24'
};
const BOTH_TEAMS_SCORE = {
    name: 'BOTH_TEAMS_SCORE',
    code: '25'
};
const HOME_TEAM_GOALS = {
    name: 'HOME_TEAM_GOALS',
    code: '26'
};
const AWAY_TEAM_GOALS = {
    name: 'AWAY_TEAM_GOALS',
    code: '27'
};
const MATCH_BETTING_BOTH_TEAMS_SCORE = {
    name: 'MATCH_BETTING_BOTH_TEAMS_SCORE',
    code: '28'
};
const WINNING_MARGIN = {
    name: 'WINNING_MARGIN',
    code: '29'
};
const CORRECT_SCORE_GROUP = {
    name: 'CORRECT_SCORE_GROUP',
    code: '30'
};
const HOME_TEAM_TO_SCORE = {
    name: 'HOME_TEAM_TO_SCORE',
    code: '35'
};
const AWAY_TEAM_TO_SCORE = {
    name: 'AWAY_TEAM_TO_SCORE',
    code: '36'
};
const FIRST_TEAM_TO_SCORE = {
    name: 'FIRST_TEAM_TO_SCORE',
    code: '37'
};
const LAST_TEAM_TO_SCORE = {
    name: 'LAST_TEAM_TO_SCORE',
    code: '38'
};
const HALF_TIME_FULL_TIME = {
    name: 'HALF_TIME_FULL_TIME',
    code: '39'
};
const TEAM_SCORECAST = {
    name: 'TEAM_SCORECAST',
    code: '40'
};
const HALF_TIME_CORRECT_SCORE = {
    name: 'HALF_TIME_CORRECT_SCORE',
    code: '41'
};
const HALF_TIME_RESULT = {
    name: 'HALF_TIME_RESULT',
    code: '42'
};

export const BET_TYPES = [
    WIN_DRAW_WIN,
    CORRECT_SCORE,
    TOTAL_GOALS,
    DOUBLE_CHANCE,
    UNDER_OVER_25,
    UNDER_OVER_15,
    ASIAN_HANDICAP,
    UNDER_OVER,
    UNDER_OVER_05,
    UNDER_OVER_35,
    BOTH_TEAMS_SCORE,
    HOME_TEAM_GOALS,
    AWAY_TEAM_GOALS,
    MATCH_BETTING_BOTH_TEAMS_SCORE,
    WINNING_MARGIN,
    CORRECT_SCORE_GROUP,
    HOME_TEAM_TO_SCORE,
    AWAY_TEAM_TO_SCORE,
    FIRST_TEAM_TO_SCORE,
    LAST_TEAM_TO_SCORE,
    HALF_TIME_FULL_TIME,
    TEAM_SCORECAST,
    HALF_TIME_CORRECT_SCORE,
    HALF_TIME_RESULT
];

export const FOOTBALL_MARKETS = BET_TYPES;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/football/constants/identifiers.js